import { useSelector } from 'react-redux'

import { RootState } from '@/store'

/**
 * Custom hook to get theme colors based on current theme mode
 * Use this hook in any component that needs dynamic theme colors
 */
export const useThemeColors = () => {
  const themeMode = useSelector((state: RootState) => state.theme.mode)
  const isDark = themeMode === 'dark'

  return {
    isDark,
    themeMode,

    // Primary colors
    primary: isDark ? '#00A19B' : '#009C92',
    primaryHover: isDark ? '#04BFAD' : '#00B6AB',
    primaryActive: isDark ? '#027373' : '#027373',

    // Background colors
    background: isDark ? '#0E0F13' : '#F5F6F7',
    backgroundSecondary: isDark ? '#1E1E1E' : '#FFFFFF',
    backgroundElevated: isDark ? '#2A2A2A' : '#E9ECEF',
    backgroundHover: isDark ? 'rgba(4, 191, 173, 0.1)' : 'rgba(0, 156, 146, 0.1)',

    // Text colors
    textPrimary: isDark ? '#FFFFFF' : '#0E0F13',
    textSecondary: isDark ? '#C1D4D9' : '#5E6B70',
    textTertiary: isDark ? '#979DA6' : '#6E7B83',
    textQuaternary: isDark ? '#565F64' : '#C8CCCE',

    // Border colors
    border: isDark ? '#565F64' : '#E9ECEF',
    borderSecondary: isDark ? '#2A2A2A' : '#F1F3F5',

    // Semantic colors
    success: isDark ? '#04BFAD' : '#00BFA6',
    warning: '#FFC107',
    error: isDark ? '#E53935' : '#D32F2F',
    info: '#027373',

    // Scrollbar
    scrollThumb: isDark ? '#565F64' : '#C8CCCE',
    scrollThumbHover: isDark ? '#979DA6' : '#979DA6',

    // Card specific
    cardBackground: isDark ? '#1E1E1E' : '#FFFFFF',
    cardBorder: isDark ? '#565F64' : '#E9ECEF',

    // Gradient
    gradient: 'linear-gradient(135deg, #00A19B 0%, #04BFAD 100%)',
  }
}
